import React, { useContext } from 'react';
import { MergeDuplicateMetricsContext } from './MergeDuplicateMetrics';
import useDuplicationWarning from '../../MetricPopup/MetricForm/NormalMetricForm/useIsDraftADuplicate';
import Alert from '../../../../../kingpin/Alert';
import { Scrollable } from '../../../../../components/UserPicker/UserPicker';
import DuplicateMetric from './DuplicateMetric';

const DuplicateMetricUsage = () => {
  const { primaryMetric, hasDatasets } = useContext(
    MergeDuplicateMetricsContext,
  );
  const duplicates = useDuplicationWarning({
    metricDraft: primaryMetric,
  }).duplicates.filter((m) => m.status !== 'archived');

  if (!primaryMetric) return null;

  return (
    <>
      <Alert
        title={(duplicates.length + 1).toString() + ' Duplicates detected.'}
        type={'Info'}
        body={
          'Choose a primary metric to merge duplicates into. The remaining metrics will be archived.'
        }
      />
      <div style={{ marginBottom: 5 }}></div>
      {hasDatasets && (
        <Alert
          title={'Dataset usage detected'}
          type={'Warning'}
          body={
            'One or more metrics are used in datasets. These will be ignored. Please update the datasets manually to use the primary metric'
          }
        />
      )}

      <Scrollable style={{ maxHeight: 400, marginTop: 5, padding: 4 }}>
        {[primaryMetric, ...duplicates].map((metric) => (
          <DuplicateMetric key={metric.id} metric={metric} />
        ))}
      </Scrollable>
    </>
  );
};

const Gate = () => {
  const { primaryMetric } = useContext(MergeDuplicateMetricsContext);

  if (!primaryMetric) return null;
  return <DuplicateMetricUsage />;
};
export default Gate;
